import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import RouteModel from "../../models/masters/route-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Route/GetAllRoute";// //{/api/Route/GetAllRoute}`)  //// "https://localhost:7054/api/Route/GetAllRoute";
export const useGetRoute = createQuery<
RouteModel[],
  null,
  AxiosError
>({
  queryKey: ["keyRoutelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
